import { api } from './client.js';

const root = '/admin/tools';

export const toolsApi = {
  // List the available AI tools with their resolved enabled state. Used to
  // decide whether to render each tool action (e.g. the extract button).
  list: () => api.get(root),

  // Extract structured customer fields from a free text draft.
  extractCustomer: (body) => api.post(`${root}/customer-extract`, body),

  // Speech to text for the draft. `formData` carries the `audio` file and an
  // optional `language` hint.
  transcribe: (formData) => api.post(`${root}/transcribe`, formData),

  // Draft the C2/C3 ORME readings from a product formulation. Returns
  // { data: { recipeReading, plateReading }, model, usage, costUsd }.
  recipeReading: (body) => api.post(`${root}/recipe-reading`, body),

  // Extract structured ingredient lines from a pasted label declaration.
  // Returns { data: { ingredients: [...] }, model, usage, costUsd }.
  extractIngredients: (text) => api.post(`${root}/ingredient-extract`, { text }),

  // Extract structured analytical constituents and additives from a pasted label
  // block. Returns { data: { analyticalConstituents: [...], additives: [...] },
  // model, usage, costUsd }.
  extractLabel: (text) => api.post(`${root}/label-extract`, { text })
};
